/*
 * @Author: cc
 * @LastEditTime: 2023-02-10 17:07:33
 */
import { log } from "console";
import { useEffect, useState } from "react";
export function useGetRandomCode<T>(str: T) {
  const [randomImgUrl, setRandomImgUrl] = useState<string>("");
  function getRandomImgFn() {
    let url = `/user/api/verify/code`;
    fetch(url)
      .then(
        (response) => {
          return response.json();
        },
        (error) => console.log("An error occurred.", error)
      )
      .then((res) => {
        setRandomImgUrl(res.data);
      });
  }
  useEffect(() => {
    getRandomImgFn();
  }, []);
  return [randomImgUrl, getRandomImgFn as any];
}
